import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import { EDITOR_CONFIG } from "../../../constants";
import JoditEditor from "jodit-react";
const AddEditGallerySession = (props) => {
  const navigate = useNavigate();
  const { id, galleryId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const editor = useRef(null);
  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [item, setItem] = useState({
    image: "",
  });

  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeRole = (newValue) => {
    setItem({ ...item, role: newValue });
  };
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };

  const [files, setFiles] = useState([]);
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts jpegs and pngs (Required size: 500x350 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "instructor");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setImageError("");
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/classes/${id}/gallery`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            image: result?.data?.data?.image ? result?.data?.data?.image : "",
            // isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Image`}
      backAction={{
        onAction: () => navigate(`/admin/${props.path}/${id}/gallery`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <Text>Image</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpeg,.jpg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
                error={true}
                errorOverlayText="aaa"
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />

          {/* <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          /> */}
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/admin/classes/${id}/gallery`)
                  .then((result) => {
                    navigate("/admin/gallerys");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!imageKey.current) {
      !imageKey.current && setImageError("Please upload an image");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      imageKey.current && form_data.append("image", imageKey.current);
      props.type === "edit" && form_data.append("_method", "PATCH");

      // form_data.append("is_active", item.isActive ? 1 : 0);
      props.type === "add"
        ? axios
            .post(`/classes/${id}/gallery`, form_data)
            .then((result) => {
              navigate(`/admin/classes/${id}/gallery`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/classes/${id}/gallery`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditGallerySession;
